import { useEffect, useRef, useState } from "react";
import { GoogleMap, LoadScriptNext } from "@react-google-maps/api";
import { Marker } from "../../theme/maps";
import { Box, Skeleton } from "@mui/material";
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import { useDispatch } from "react-redux";
import { coverageAreaByGeocode } from "../../utils";
import { colors } from "../ui/colors";

export const MapComponent = ({
  width = 1120,
  minResizeWidth = 800,
  height = 400,
  store,
  storeAction,
  setLocalStore,
  focusStore,
  sx,
  disableLoadScript = false
}) => {
  const [isLoaded, setILoaded] = useState(false);
  const [size, setSize] = useState({ width, height });
  const mapRef = useRef(null);  
  const dispatch = useDispatch();

  const handleMapClick = (event) => {
    const lat = event.latLng.lat();
    const lng = event.latLng.lng();

    coverageAreaByGeocode({ lat, lng })
      .then((coverageArea) => {
        const newArea = { ...coverageArea, latitude: lat, longitude: lng };
        if (storeAction) {
          const action = storeAction([...store, newArea]);
          if (action && typeof action === "object" && typeof action.type === "string") {
            dispatch(action);
          }
        } else if (setLocalStore) {
          setLocalStore((prev) => [...prev, newArea]);
        }
      })
      .catch(() => {
        const newArea = { address: "Dirección no encontrada", latitude: lat, longitude: lng };
        if (storeAction) {
          const action = storeAction([...store, newArea]);
          if (action && typeof action === "object" && typeof action.type === "string") {
            dispatch(action);
          }
        } else if (setLocalStore) {
          setLocalStore((prev) => [...prev, newArea]);
        }
      });
  };

  useEffect(() => {
    if (mapRef.current && focusStore) {
      mapRef.current.panTo({
        lat: parseFloat(focusStore.latitude),
        lng: parseFloat(focusStore.longitude),
      });
      mapRef.current.setZoom(14);
    }
  }, [focusStore]);

  const mapContent = (
    <ResizableBox
      width={size.width}
      height={size.height}
      axis="x"
      minConstraints={[minResizeWidth, height]}
      maxConstraints={[width, height]}
      onResizeStop={(event, { size }) => setSize(size)}
    >
      <Box sx={{ width: "100%", height: "100%", borderRadius: "10px", position: "relative" }}>
        {!isLoaded && (
          <Skeleton variant="rectangular" sx={{ width: "100%", height: "100%", borderRadius: "10px" }} />
        )}
        <GoogleMap
          onLoad={(map) => {
            setILoaded(true);
            mapRef.current = map;  
          }}
          onClick={handleMapClick}
          mapContainerStyle={{
            width: "100%",
            height: "100%",
            border: "4px solid",
            borderRadius: 6,
            borderColor: colors.orange[100],
          }}
          zoom={8}
          options={{ fullscreenControl: false, streetViewControl: false }}
          center={
            focusStore
              ? { lat: parseFloat(focusStore.latitude), lng: parseFloat(focusStore.longitude) }
              : { lat: 39.748116, lng: -104.770598 }
          }
        >
          {store?.map((coverage, index) => (
            <Marker
              key={coverage.id || index}
              position={{
                lat: parseFloat(coverage.latitude),
                lng: parseFloat(coverage.longitude),
              }}
            />
          ))}
        </GoogleMap>
      </Box>
    </ResizableBox>
  );

  return (
    <Box sx={{ ...sx }}>
      {disableLoadScript ? (
        mapContent
      ) : (
        <LoadScriptNext googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY} libraries={["places"]}>
          {mapContent}
        </LoadScriptNext>
      )}
    </Box>
  );
};
